import { createFileRoute } from '@tanstack/react-router';

import { CreateQuotePage } from '../offer/quote/CreateQuotePage';

export const Route = createFileRoute('/_app/offer/$id_/quote')({
    component: CreateQuotePage,
});
